module.exports = __webpack_public_path__ + "static/media/gb-wls.2ba40b94.svg";